import React, { FC } from 'react';
import { useAppSelector } from '@src/redux';
import { getIsBodyBackdropVisible } from '@src/redux/selectors/bodyBackdrop';
import './styles.scss';

export const BodyBackdrop: FC = () => {
  const isBodyBackdropVisible = useAppSelector(getIsBodyBackdropVisible);

  if (!isBodyBackdropVisible) {
    return null;
  }

  return <div className="body-backdrop" />;
};
